import React, { useState, useEffect } from 'react';

function UserProfile({ userID }) {
    const [user, setUser] = useState({});

    useEffect(() => {
        fetch(`https://dummyjson.com/user/${userID}`)
            .then(response => response.json())
            .then(data => {
                console.log(data);
                setUser(data);
            });
    }, [userID]); // Dependency array includes userID to refetch when it changes

    return (
        <div>
            {user ? (
                <div>
                    <h1>{user.firstName} {user.lastName}</h1>
                    <p>{user.email}</p>
                    <img src={"https://i.pravatar.cc/150?img=" + user.id} alt='Alternative text' className='image'/>
                </div>
            ) : (
                <p>Loading...</p>
            )}
        </div>
    );
}

export default UserProfile;
